import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { isConfigured } from "./lib/qubbase";
import { applyTheme } from "./lib/theme";
import "./index.css";

applyTheme();

function NotConfigured() {
  return (
    <div className="mx-auto max-w-xl px-6 py-20 text-sm">
      <h1 className="text-xl font-semibold">Connect a QubBase project</h1>
      <p className="mt-3 text-soft">
        Set <code className="font-mono">VITE_QUBBASE_URL</code> and{" "}
        <code className="font-mono">VITE_QUBBASE_ANON_KEY</code> in{" "}
        <code className="font-mono">apps/base-sample/.env.local</code>, or run
        the setup script, which creates the project and writes the file for you:
      </p>
      <pre className="mt-4 overflow-x-auto rounded-lg bg-sunken p-4 font-mono text-xs">
        {
          "pnpm --filter @qub/base-sample qubbase:setup --email you@example.com --password ••••••"
        }
      </pre>
      <p className="mt-3 text-muted">Then restart the dev server.</p>
    </div>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>{isConfigured ? <App /> : <NotConfigured />}</StrictMode>,
);
